import { useEffect } from "react";

const DOMAIN = "https://jackiannottiflowers.com";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function Seo({ title, description, jsonLd }) {
  useEffect(() => {
    const path = window.location.pathname === "/" ? "/" : window.location.pathname;
    const url = `${DOMAIN}${path}`;
    upsertLink("canonical", url);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", `${DOMAIN}/images/shop-2.webp`);
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    document.head.querySelectorAll("script[data-route-jsonld]").forEach((s) => s.remove());
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-route-jsonld", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, jsonLd]);
  return null;
}
